import { graphql, useStaticQuery } from "gatsby";
import { getSrc } from "gatsby-plugin-image";
import constructUrl from "./constructUrl";

type DataProps = {
  title: string;
  frontmatter?: Queries.BlogPostFrontmatterFragment;
};

export type SiteMetadata = {
  title: string;
  fullTitle: string;
  description: string;
  logoPath: string;
  imagePath: string;
  author: string;
};

export default function useSiteMetadata(data: DataProps): SiteMetadata {
  const { site, ogImageDefault, ogLogo } = useStaticQuery(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          title
          description
          author
          siteUrlForEnv
        }
      }
      ogImageDefault: file(relativePath: { eq: "dolt-graphic-blog.png" }) {
        childImageSharp {
          gatsbyImageData(
            height: 627
            width: 1200
            placeholder: BLURRED
            layout: FIXED
          )
        }
      }
      ogLogo: file(relativePath: { eq: "dolthub-logo-new.png" }) {
        childImageSharp {
          gatsbyImageData(
            height: 627
            width: 1200
            placeholder: BLURRED
            layout: FIXED
          )
        }
      }
    }
  `);

  return {
    title: data.title,
    fullTitle: `${data.title} | ${site.siteMetadata.title}`,
    description: data.frontmatter?.description ?? site.siteMetadata.description,
    author: site.siteMetadata.author,
    imagePath: constructUrl(
      site.siteMetadata.siteUrlForEnv,
      getSrc(data.frontmatter?.featuredImage ?? ogImageDefault)
    ),
    logoPath: constructUrl(site.siteMetadata.siteUrlForEnv, getSrc(ogLogo)),
  };
}
